<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors[`${field}.region`] }"
      )
        .form-elem__title Регион
        .form-elem__body
          multiselect.custom-multiselect(
          v-model="region"
          placeholder="Выберите регион",
          :options="regionsList"
          :label="'value'"
          :multiple="false"
          :showLabels="false"
          :closeOnSelect="true"
          :allowEmpty="true"
          :clearOnSelect="false"
          @search-change="asyncFindRegion"
          @input="onSelectRegion"
          )
            template(
            slot="noOptions"
            ) Начните вводить название
            template(
            slot="noResult"
            ) Ничего не найдено
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors[`${field}.area`]  }"
      )
        .form-elem__title Район
        .form-elem__body
          multiselect.custom-multiselect(
          v-model="area"
          placeholder="Выберите район",
          :options="areasList"
          :label="'value'"
          :multiple="false"
          :showLabels="false"
          :closeOnSelect="true"
          :allowEmpty="true"
          :clearOnSelect="false"
          @search-change="asyncFindArea"
          @input="onSelectArea"
          )
            template(
            slot="noOptions"
            ) Начните вводить название
            template(
            slot="noResult"
            ) Ничего не найдено
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors[`${field}.city`]  }"
      )
        .form-elem__title Город
        .form-elem__body
          multiselect.custom-multiselect(
          v-model="city"
          placeholder="Выберите город",
          :options="citiesList"
          :label="'value'"
          :multiple="false"
          :showLabels="false"
          :closeOnSelect="true"
          :allowEmpty="true"
          :clearOnSelect="false"
          @search-change="asyncFindCity"
          @input="onSelectCity"
          )
            template(
            slot="noOptions"
            ) Начните вводить название
            template(
            slot="noResult"
            ) Ничего не найдено
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors[`${field}.street`]  }"
      )
        .form-elem__title Улица
        .form-elem__body
          multiselect.custom-multiselect(
          v-model="street"
          placeholder="Выберите улицу",
          :options="streetsList"
          :label="'value'"
          :multiple="false"
          :showLabels="false"
          :closeOnSelect="true"
          :allowEmpty="true"
          :clearOnSelect="false"
          @search-change="asyncFindStreet"
          @input="onSelectStreet"
          )
            template(
            slot="noOptions"
            ) Начните вводить название
            template(
            slot="noResult"
            ) Ничего не найдено
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors[`${field}.house`]  }"
      )
        .form-elem__title Дом
        .form-elem__body
          multiselect.custom-multiselect(
          v-model="house"
          placeholder="Выберите номер дома",
          :options="housesList"
          :label="'value'"
          :multiple="false"
          :showLabels="false"
          :closeOnSelect="true"
          :allowEmpty="true"
          :clearOnSelect="false"
          @search-change="asyncFindHouse"
          @input="onSelectHouse"
          )
            template(
            slot="noOptions"
            ) Начните вводить номер дома
            template(
            slot="noResult"
            ) Ничего не найдено
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Квартира
        .form-elem__body
          input.input.input_full(
          v-model="apartment"
          @input="onChangeValue('apartment', apartment)"
          maxlength=50
          )
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors[`${field}.postal_code`] }"
      )
        .form-elem__title Индекс
        .form-elem__body
          input.input.input_full(
          v-model="postal_code"
          maxlength="6"
          @input="onChangeValue('postal_code', postal_code)"
          ref="postal_code"
          )
    .form__elem.form__elem_full(
      v-if="showAttachments"
    )
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors.registration_documents_attachments }"
      )
        .form-elem__title Документ
        .form-elem__body
          attach-file(
          :attachments="localAttachments"
          attachment-type="registration_documents_attachments"
          fieldname="registration_documents_attachments"
          @onChangeAttachments="changeAttachments"
          :keymonitor="keymonitor"
          )
          .form-elem__description Свидетельство о регистрации или страница паспорта, где указан адрес регистрации
</template>
<script>
import {mapActions} from "vuex";
import CustomInput from "@/components/customInput/CustomInput";
import Multiselect from "vue-multiselect";
import AttachFile from "@/components/attach-file/AttachFile";
import Inputmask from "inputmask";

export default {
  name: "FormAddress",
  components: {
    CustomInput,
    Multiselect,
    AttachFile
  },
  props: {
    address: {
      type: Object,
      default: () => ({})
    },
    requireErrors: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: String,
      default: ""
    },
    showAttachments: {
      type: Boolean,
      default: false
    },
    attachments: {
      type: Array,
      default: () => []
    },
    keymonitor: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      interval: null,
      url: "suggest/address",
      regionsList: [],
      region: null,
      areasList: [],
      area: null,
      citiesList: [],
      city: null,
      streetsList: [],
      street: null,
      housesList: [],
      house: null,
      apartment: "",
      postal_code: "",
      postalCodeMask: new Inputmask({
        placeholder: "",
        allowMinus: false,
        rightAlign: false,
        mask: "999999",
        showMaskOnHover: false,
        showMaskOnFocus: false
      })
    };
  },
  computed: {
    localAttachments: {
      get() {
        return this.attachments;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "registration_documents_attachments"]);
      }
    }

  },
  methods: {
    ...mapActions(["getSuggetionDaData"]),
    setFields(address) {
      this.region = {
        value: address.region
      };
      this.area = {
        value: address.area
      };
      this.city = {
        value: address.city
      };
      this.street = {
        value: address.street
      };
      this.house = {
        value: address.house
      };
      this.apartment = address.apartment;
      this.postal_code = address.postal_code;
    },

    asyncFindRegion(query) {
      // this.$emit("reset-error", `${this.field}.region`);
      this.keymonitor();
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        const params = {
          query: query,
          count: 10,
          from_bound: {
            value: "region"
          },
          to_bound: {
            value: "region"
          }
        };
        this.getSuggetionDaData({
          data: params,
          url: this.url
        }).then(suggetion => {
          this.regionsList = suggetion.data.suggestions;
        });
        clearInterval(this.interval);
      }, 500);
    },
    onSelectRegion(val) {
      if (!val) {
        this.region = {
          value: null
        };
      } else {
        this.region = {
          value: val.value,
          id: val.data.region_fias_id
        };
      }
      this.$emit("on-change-value", this.field, "region", this.region.value);
    },
    asyncFindArea(query) {
      // this.$emit("reset-error", `${this.field}.area`);
      this.keymonitor();
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        const params = {
          query: query,
          count: 10,
          from_bound: {
            value: "area"
          },
          to_bound: {
            value: "area"
          }
        };
        if (this.region && this.region.id) {
          params.locations = [{
            region_fias_id: this.region.id
          }];
        }
        this.getSuggetionDaData({
          data: params,
          url: this.url
        }).then(suggetion => {
          this.areasList = suggetion.data.suggestions;
        });
        clearInterval(this.interval);
      }, 500);
    },
    onSelectArea(val) {
      if (!val) {
        this.area = {
          value: null
        };
      } else {
        this.area = {
          value: val.data.area,
          id: val.data.area_fias_id
        };
      }
      this.$emit("on-change-value", this.field, "area", this.area.value);
    },
    asyncFindCity(query) {
      // this.$emit("reset-error", `${this.field}.city`);
      this.keymonitor();
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        const params = {
          query: query,
          count: 10,
          from_bound: {
            value: "city"
          },
          to_bound: {
            value: "settlement"
          }
        };

        if (this.area && this.area.id) {
          params.locations = [{
            area_fias_id: this.area.id
          }];
        } else if (this.region && this.region.id) {
          params.locations = [{
            region_fias_id: this.region.id
          }];
        }
        this.getSuggetionDaData({
          data: params,
          url: this.url
        }).then(suggetion => {
          this.citiesList = suggetion.data.suggestions;
        });
        clearInterval(this.interval);
      }, 500);
    },
    onSelectCity(val) {
      if (!val) {
        this.city = {
          value: null
        };
      } else {
        if (val.data.city_with_type) {
          this.city = {
            value: val.data.city_with_type,
            id: val.data.city_fias_id
          };
        } else {
          this.city = {
            value: val.data.settlement_with_type,
            id: val.data.settlement_fias_id
          };
        }
      }
      this.$emit("on-change-value", this.field, "city", this.city.value);
      if (!this.area.value) {
        if (!val.data.area) {
          this.area = {
            value: this.city.value,
            id: this.city.id
          };
        } else {
          this.area = {
            value: val.data.area,
            id: val.data.area_fias_id
          };
        }
        this.$emit("on-change-value", this.field, "area", this.area.value);
      }
    },
    asyncFindStreet(query) {
      // this.$emit("reset-error", `${this.field}.street`);
      this.keymonitor();
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        const params = {
          query: query,
          count: 10,
          from_bound: {
            value: "street"
          },
          to_bound: {
            value: "street"
          }
        };
        if (this.city && this.city.id) {
          params.locations = [
            {
              city_fias_id: this.city.id
            },
            {
              settlement_fias_id: this.city.id
            }
          ];
        }
        this.getSuggetionDaData({
          data: params,
          url: this.url
        }).then(suggetion => {
          this.streetsList = suggetion.data.suggestions;
        });
        clearInterval(this.interval);
      }, 500);
    },
    onSelectStreet(val) {
      if (!val) {
        this.street = {
          value: null
        };
      } else {
        this.street = {
          value: val.data.street_with_type,
          id: val.data.street_fias_id
        };
      }
      this.$emit("on-change-value", this.field, "street", this.street.value);
    },
    asyncFindHouse(query) {
      // this.$emit("reset-error", `${this.field}.house`);
      this.keymonitor();
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        const params = {
          query: query,
          count: 10,
          from_bound: {
            value: "house"
          },
          to_bound: {
            value: "house"
          }
        };
        if (this.street && this.street.id) {
          params.locations = [
            {
              street_fias_id: this.street.id
            }
          ];
        }
        this.getSuggetionDaData({
          data: params,
          url: this.url
        }).then(suggetion => {
          this.housesList = suggetion.data.suggestions;
        });
        clearInterval(this.interval);
      }, 500);
    },
    onSelectHouse(val) {
      if (!val) {
        this.house = {
          value: null
        };
      } else {
        this.house = {
          value: val.data.house,
          id: val.data.house_fias_id
        };
      }
      this.$emit("on-change-value", this.field, "house", this.house.value);
    },

    onChangeValue(item, value) {
      // this.$emit("reset-error", `${this.field}.${item}`);
      this.keymonitor();
      this.$emit("on-change-value", this.field, item, value);
    },
    changeAttachments(data) {
      this.$emit("on-change-attachments", [data.value, data.fieldname]);
      this.keymonitor();
    }
  },
  created() {
    this.setFields(this.address);
  },
  mounted() {
    this.postalCodeMask.mask(this.$refs.postal_code);
  },
  watch: {
    address(val) {
      this.setFields(this.address);
    }
  }
};
</script>
